import {createTheme} from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2A9D8F', // Basil Green
            light: '#F9C74F', // Tuscan Sun
            dark: '#720026'  // Chianti
        },
        secondary: {
            main: '#E63946', // Marinara Red
            light: '#F4A261', // Olive Oil Gold
            dark: '#720026'  // Chianti
        },
        error: {
            main: '#720026', // Chianti (for errors)
        },
        background: {
            default: '#F1FAEE',  // Mozzarella White
            paper: '#FAF9F6', // Parmesan Cream
        },
        text: {
            primary: '#333333', // Dark text for readability
            secondary: '#555555' // Slightly lighter, for less emphasis
        }
    }
});

export default theme;
